import { jsxs as c, jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M22.147 33.022h2c0-4.342 3.533-7.875 7.875-7.875v-2c-5.445 0-9.875 4.43-9.875 9.875Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32 18.522c-8.015 0-14.513 6.485-14.513 14.483 0 5.39 2.951 10.093 7.329 12.586l.756 5.306h.776l.726 6.326h9.852l.726-6.326h.776l.756-5.306c4.378-2.493 7.329-7.196 7.329-12.586 0-7.999-6.498-14.483-14.513-14.483Zm2.935 36.469h-5.87l-.109-.95h6.088l-.11.95Zm.338-2.95h-6.546l-.127-1.1h6.8l-.127 1.1Zm6.658-13.178a11.598 11.598 0 0 1-4.22 4.142l-1.268.722-.206 1.444-.392 2.75h-7.69l-.392-2.75-.206-1.444-1.267-.722a11.597 11.597 0 0 1-4.221-4.142 11.465 11.465 0 0 1-1.605-5.858c0-3.072 1.2-5.96 3.377-8.134A11.475 11.475 0 0 1 32 21.5c3.083 0 5.98 1.198 8.16 3.373a11.415 11.415 0 0 1 3.376 8.133c0 2.067-.555 4.092-1.605 5.858ZM33.1 7.327h-2v8.244h2V7.327ZM14.633 14.115l-1.414 1.414 5.83 5.83 1.414-1.414-5.83-5.83ZM14.62 31.973H6.375v2h8.245v-2ZM18.992 44.61l-5.83 5.83 1.415 1.414 5.83-5.83-1.415-1.414ZM45.072 44.666l-1.414 1.414 5.83 5.83 1.414-1.414-5.83-5.83ZM57.746 32.052h-8.244v2h8.244v-2ZM49.544 14.17 43.714 20l1.414 1.415 5.83-5.83-1.414-1.414Z"
        }
      )
    ]
  }
);
export {
  o as SpecialEffects
};
